import React from "react";
import "./ProjectCard.css";

const ProjectCard = ({ img, name, description, link }) => {
  return (
    <div className="card-container">
      <img src={img} alt={name} className="card-image" />
      <div className="card-content">
        <h2 className="card-title">{name}</h2>
        <p className="card-description">{description}</p>
      </div>
      <a href={link} className="card-link" target="_blank" rel="noopener noreferrer">
          Link
        </a>
    </div>
  );
};

export default ProjectCard;
